/**
 * @file banner
 * @author 丁聪
 */

import React, { Component } from 'react'
import './index.scss'

class People extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() { }

    render() {
        return (
            <div id="people">
                <div className="peo-pic">
                    <div className="peo-text">
                        孩子妈妈
                    </div>
                </div>
                <div className="peo-pic2">
                    <div className="peo-text">
                        机构负责人
                    </div>
                </div>
                <div className="peo-pic3">
                    <div className="peo-text">
                        职场白领
                    </div>
                </div>
                <div className="peo-pic4">
                    <div className="peo-text">
                        留学生
                    </div>
                </div>
            </div>
        )
    }
}

export default People
